'use client';

import { c as _c } from "react/compiler-runtime";
import { defaultLayoutIcons, DefaultVideoLayout } from '@vidstack/react/player/layouts/default';
import VidstackPlayer from './VidstackPlayer';
import '@vidstack/react/player/styles/default/theme.css';
import '@vidstack/react/player/styles/default/layouts/video.css';
const VidstackVideoPlayer = t0 => {
  const $ = _c(15);
  const {
    source,
    poster,
    volume: t1,
    muted: t2,
    isPlaying,
    onPlay,
    onPause,
    onSeekRequest,
    onTimeUpdate,
    onVolumeChange,
    onError,
    onLoaded,
    onLoadStart
  } = t0;
  const volume = t1 === undefined ? 1 : t1;
  const muted = t2 === undefined ? false : t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <DefaultVideoLayout icons={defaultLayoutIcons} />;
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== isPlaying || $[2] !== muted || $[3] !== onError || $[4] !== onLoadStart || $[5] !== onLoaded || $[6] !== onPause || $[7] !== onPlay || $[8] !== onSeekRequest || $[9] !== onTimeUpdate || $[10] !== onVolumeChange || $[11] !== poster || $[12] !== source || $[13] !== volume) {
    t4 = <VidstackPlayer source={source} poster={poster} volume={volume} muted={muted} isPlaying={isPlaying} onPlay={onPlay} onPause={onPause} onSeekRequest={onSeekRequest} onTimeUpdate={onTimeUpdate} onVolumeChange={onVolumeChange} onError={onError} onLoaded={onLoaded} onLoadStart={onLoadStart}>{t3}</VidstackPlayer>;
    $[1] = isPlaying;
    $[2] = muted;
    $[3] = onError;
    $[4] = onLoadStart;
    $[5] = onLoaded;
    $[6] = onPause;
    $[7] = onPlay;
    $[8] = onSeekRequest;
    $[9] = onTimeUpdate;
    $[10] = onVolumeChange;
    $[11] = poster;
    $[12] = source;
    $[13] = volume;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
};
export default VidstackVideoPlayer;